<ion-header
  id="header"
  [ngClass]="{
    'red-web-header': (useMobileLayout$ | async) === false
  }"
>
  <ng-content></ng-content>
</ion-header>
